import CancellableHelper from "../CancellableHelper";
import { BSPReportResponse } from "@/models/api/report/BSPReport";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { BSPTicketResponse } from "@/models/api/report/BSPTicket";
import { BSPFinancialProperty } from "@/models/api/report/BSPFinancialProperty";
import { BSPBookingItemMatchResponse } from "@/models/api/report/BSPBookingItemMatch";
import { axiosInstance } from "@/plugins/axios";
import { FileTmp } from "@/models/api/Files";

export const URL_GET_BSP_REPORT_LIST = "/Report/GetBSPReportList";
export const URL_GET_BSP_TICKET_LIST = "/Report/GetBSPTicketList/${ReportId}";
export const URL_GET_BSP_TICKET_INFO = "/Report/GetBSPTicketInfo";
export const URL_GET_BSP_BOOKING_ITEM_LIST = "/Report/GetBSPBookingItemList/${TicketId}";
export const URL_POST_DELETE_BSP_REPORT = "/Report/DeleteBSPReport/${ReportId}";
export const URL_POST_UPLOAD_BSP_STATEMENT_FILE = "/File/UploadBSPStatementFile";
export const URL_POST_PARSE_BSP_STATEMENT = "/Report/ParseBSPStatements";
export const URL_POST_MANUAL_BSP_MATCH = "/Report/ManualBSPMatch";
export const URL_POST_REMOVE_BSP_MATCH = "/Report/RemoveBSPMatch";
export const URL_POST_MATCH_TICKETS = "/Report/MatchTickets";

//#region
const _getBSPReportList = new CancellableHelper<BSPReportResponse>(URL_GET_BSP_REPORT_LIST, BSPReportResponse);
_getBSPReportList.jsonSerializer = true;
export const getBSPReportList = async (genericTableRequest: GenericTableRequest): Promise<BSPReportResponse> => {
  return await _getBSPReportList.get(genericTableRequest);
};

const _getBSPTicketList = new CancellableHelper<BSPTicketResponse>(URL_GET_BSP_TICKET_LIST, BSPTicketResponse);
_getBSPTicketList.jsonSerializer = true;
export const getBSPTicketList = async (
  genericTableRequest: GenericTableRequest,
  reportId: number
): Promise<BSPTicketResponse> => {
  return await _getBSPTicketList.get({
    ...genericTableRequest,
    ReportId: reportId,
  });
};

const _getBSPTicketInfo = new CancellableHelper<BSPFinancialProperty>(URL_GET_BSP_TICKET_INFO, BSPFinancialProperty);
export const getBSPTicketInfo = async (ticketId: number): Promise<BSPFinancialProperty> => {
  return await _getBSPTicketInfo.get({ TicketId: ticketId });
};

const _getBSPBookingItemList = new CancellableHelper<BSPBookingItemMatchResponse>(
  URL_GET_BSP_BOOKING_ITEM_LIST,
  BSPBookingItemMatchResponse
);
_getBSPBookingItemList.jsonSerializer = true;
export const getBSPBookingItemList = async (
  genericTableRequest: GenericTableRequest,
  ticketId: number
): Promise<BSPBookingItemMatchResponse> => {
  return await _getBSPBookingItemList.get({
    ...genericTableRequest,
    TicketId: ticketId,
  });
};

const _postDeleteBSPReport = new CancellableHelper<void>(URL_POST_DELETE_BSP_REPORT, null, true);
export const postDeleteBSPReport = async (reportId: number): Promise<void> => {
  return await _postDeleteBSPReport.post({ ReportId: reportId }, null);
};

export const postUploadBSPStatementFile = async (files: Array<File>): Promise<Array<FileTmp>> => {
  const formData = new FormData();
  for (const file of files) {
    formData.append(file.name, file);
  }
  const response = await axiosInstance.post(URL_POST_UPLOAD_BSP_STATEMENT_FILE, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data as Array<FileTmp>;
};

const _postParseBSPStatements = new CancellableHelper<null>(URL_POST_PARSE_BSP_STATEMENT, null, true);
export const postParseBSPStatements = async (tmpFileIdList: Array<number>): Promise<void> => {
  await _postParseBSPStatements.post({ TmpFileIdList: tmpFileIdList }, null);
};

const _postManualBSPMatch = new CancellableHelper<null>(URL_POST_MANUAL_BSP_MATCH, null, true);
export const postManualBSPMatch = async (bookingItemId: number, ticketId: number): Promise<void> => {
  await _postManualBSPMatch.post({ BookingItemId: bookingItemId, TicketId: ticketId }, null);
};

const _postRemoveBSPMatch = new CancellableHelper<null>(URL_POST_REMOVE_BSP_MATCH, null, true);
export const postRemoveBSPMatch = async (bookingItemId: number): Promise<void> => {
  await _postRemoveBSPMatch.post({ BookingItemId: bookingItemId }, null);
};

const _postMatchTickets = new CancellableHelper<null>(URL_POST_MATCH_TICKETS, null, true);
export const postMatchTickets = async (reportId: number): Promise<void> => {
  await _postMatchTickets.post({ ReportId: reportId }, null);
};
//#endregion
